import Box, { type BoxProps } from '@mui/material/Box';
import Paper, { type PaperProps } from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const FeaturedCarTileWrapper = styled(Paper)<PaperProps>(() => ({
  borderRadius: '2rem',
  boxSizing: 'border-box',
  containerType: 'inline-size',
  display: 'flex',
  flexDirection: 'row',
  overflow: 'hidden',
  // NOTE: If this padding changes, update any container queries that take this into account!
  padding: '0.5rem',

  '&[data-orientation="vertical"]': {
    flexDirection: 'column',
  },
}));

export const GalleryWrapper = styled(Box)<BoxProps>(() => ({
  aspectRatio: '4 / 3',
  borderRadius: '1.5rem',
  flex: '0 0 auto',
  overflow: 'hidden',
  position: 'relative',
  width: '100%',

  '[data-orientation="horizontal"] &': {
    flex: '0 1 auto',
    height: 300,
    maxWidth: 400,
    minWidth: 320,

    // NOTE: The 1rem accounts for padding on the container!
    // Image will shrink to a smaller width to save space for text.
    '@container (width < calc(800px - 1rem))': {
      maxWidth: 320,
    },
  },

  '.kmx-car-tile__favorite-button': {
    fontSize: '1.5rem',
    position: 'absolute',
    right: '0.5rem',
    top: '0.5rem',
    zIndex: 2,
  },

  '> a': {
    display: 'block',
    height: '100%',
    width: '100%',

    '> img': {
      height: '100%',
      objectFit: 'cover',
      width: '100%',
    },
  },
}));

export const Content = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(0, 4, 0, 5),

  '[data-orientation="vertical"] &': {
    padding: theme.spacing(1),
  },
}));
